import React from "react";
import Login from "../../../components/_auth/Login/Login";

const Authorisation = () => {
  return <Login />;
};

export default Authorisation;
